import React, { useState, useEffect } from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import { Modal } from 'react-bootstrap';
import { faXmark } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import "../../../Modals/ModalStyle.css";
import middleware from "../../../Api/Middleware";
import { RegularCheckBox } from '../../../HouseStyle/Components/Checkboxes';
import { ButtonBlue, ButtonLightGrey } from '../../../HouseStyle/Components/Buttons';
import ToastSuccess from '../../../Toasts/ToastSuccess';
import ToastError from '../../../Toasts/ToastError';

const ProductSeasonModal = ({ show, onHide, productId, currentSeasonIds = [], onSeasonsSaved }) => {
  const [seasons, setSeasons] = useState([]);
  const [selectedSeasonIds, setSelectedSeasonIds] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (show) {
      fetchSeasons();
      setSelectedSeasonIds(currentSeasonIds);
    }
  }, [show, currentSeasonIds]);

  const fetchSeasons = async () => {
    setLoading(true);
    try {
      const response = await middleware.get('products/seasons?status=1');
      setSeasons(response.data.data || []);
    } catch (error) {
      console.error('Error fetching seasons:', error);
      ToastError('Fout bij het ophalen van seizoenen');
    } finally {
      setLoading(false);
    }
  };

  const handleToggleSeason = (seasonId) => {
    setSelectedSeasonIds(prev => {
      if (prev.includes(seasonId)) {
        return prev.filter(id => id !== seasonId);
      } else {
        return [...prev, seasonId];
      }
    });
  };

  const handleSave = async () => {
    try {
      if (currentSeasonIds.length > 0) {
        const deletePromises = currentSeasonIds.map(seasonId =>
          middleware.delete(`products/hasseasons?product_id=${productId}&season_id=${seasonId}`)
        );
        await Promise.all(deletePromises);
      }

      if (selectedSeasonIds.length > 0) {
        const bulkData = selectedSeasonIds.map(seasonId => ({
            product_id: productId,
            season_id: seasonId
        }));

        await middleware.post(`products/hasseasons`, {
          bulk_data:  bulkData
        });
      }

      ToastSuccess('Seizoenen succesvol bijgewerkt');

      if (onSeasonsSaved) {
        onSeasonsSaved();
      }

      onHide();
    } catch (error) {
      console.error('Error saving seasons:', error);
      ToastError('Fout bij het opslaan van seizoenen');
    }
  };

  const formatSeasonName = (season) => {
    if (season.sub_season) {
      return `${season.head_season} - ${season.sub_season}`;
    }
    return season.head_season;
  };

  return (
    <Modal
      show={show}
      onHide={onHide}
      size="xl"
      centered
    >
      <Modal.Header className="modalTop d-flex justify-content-between">
        <h4 className="mb-0 fw-semibold">
          Seizoenen koppelen
        </h4>
        <button
          className="border-0 bg-transparent"
          onClick={onHide}
        >
          <FontAwesomeIcon icon={faXmark} className="closeModal" />
        </button>
      </Modal.Header>
      <Modal.Body className="modalCenter">
        <div className="contendModal w-100">
          {loading ? (
            <div className="text-center py-4">
              <div className="spinner-border text-primary" role="status">
                <span className="visually-hidden">Loading...</span>
              </div>
            </div>
          ) : seasons.length === 0 ? (
            <div className="text-center py-4 text-muted">
              Geen seizoenen gevonden. Voeg eerst seizoenen toe.
            </div>
          ) : (
            <div className="d-flex flex-column gap-3">
              <p className="text-muted mb-2">
                Selecteer de seizoenen die van toepassing zijn op dit product:
              </p>
              <div
                className="d-flex flex-column gap-3"
                style={{
                  maxHeight: '400px',
                  overflowY: 'auto',
                  paddingRight: '10px'
                }}
              >
                {seasons.map((season) => (
                  <div key={season.season_id} className="d-flex align-items-center">
                    <RegularCheckBox
                      value={selectedSeasonIds.includes(season.season_id)}
                      setValue={() => handleToggleSeason(season.season_id)}
                      label={formatSeasonName(season)}
                    />
                  </div>
                ))}
              </div>
            </div>
          )}
        </div>
      </Modal.Body>
      <Modal.Footer className="modalBottom d-flex flex-row justify-content-between">
        <ButtonLightGrey
          text="Annuleren"
          onClickFunction={onHide}
        />
        <ButtonBlue
          text="Opslaan"
          onClickFunction={handleSave}
          disabled={loading || seasons.length === 0}
        />
      </Modal.Footer>
    </Modal>
  );
};

export default ProductSeasonModal;

